export const DATA_URL =
  process.env.NODE_ENV !== "production"
    ? "/api/chart/"
    : "https://texas.inmagik.com/api/chart/";

export const FILE_URL =
  process.env.NODE_ENV !== "production"
    ? "/api/indicators"
    : "https://texas.inmagik.com/api/indicators";
